import { render, staticRenderFns } from "./ApprovedByMeList.vue?vue&type=template&id=61c5f83e&"
import script from "./ApprovedByMeList.vue?vue&type=script&lang=js&"
export * from "./ApprovedByMeList.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedByMeList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports